import './Checkout.css';
import React, { useContext, useEffect, useState } from 'react';
import { CHECKOUT_FORM_DEFAULT_STATE } from '../../helpers/checkout-constants';
import { CartContext } from '../../store/CartContext';
import { CheckoutContext, Environments, PaymentOptions, SourceOptions } from '../../store/CheckoutContext';
import StepFirst from './StepFirst';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { VALIDATION_SCHEMA } from '../../helpers/checkout-validation-schema';
import { getApiKeys, getDemoKeys, getPaymentBody } from '../../helpers/checkout-helpers';
import { eligibility } from '../../helpers/checkout-api';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useLocation } from 'react-router-dom';
import StepSecond from './StepSecond';
import StepThird from './StepThird';

import './Steps.css';

interface Props {}

const CheckoutSteps: React.FC<Props> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart } = useContext(CartContext);
  const {
    environment,
    setPaymentErrors,
    setLoading,
    redirect,
    iframeSize,
    paymentOptions,
    sourceOptions,
    setErrors,
    loading,
  } = useContext(CheckoutContext);

  const [state, setState] = useState<{ [key: string]: any }>({
    transactionAmount:
      cart?.reduce((total, cartItem) => total + cartItem.quantity * cartItem.item.price, 0).toFixed(2) || 0,
    ...CHECKOUT_FORM_DEFAULT_STATE,
    mid: localStorage.getItem('mid') || '',
  });

  const [orderId] = useState<string>(uuidv4());
  const [step, setStep] = useState(1);

  useEffect(() => {
    let keys: { spreedlyKey: string; appKey: string; appSecret: string; mid?: string; siteId?: string } = getApiKeys();

    if (location.pathname.includes('demo') && (!keys.appKey || !keys.appSecret || !keys.spreedlyKey)) {
      keys = getDemoKeys();
    }

    if (keys?.appKey?.length > 0 || keys?.appSecret.length > 0 || keys?.spreedlyKey.length > 0) {
      setState({
        ...state,
        appKey: keys?.appKey,
        appSecret: keys?.appSecret,
        spreedlyKey: keys?.spreedlyKey,
        mid: keys?.mid,
        siteId: keys?.siteId,
      });
    }
  }, []);

  async function paymentHandler() {
    if ((window as any).UIWidget) {
      state.sourceOptions = sourceOptions === SourceOptions.empty ? null : sourceOptions;

      let body = getPaymentBody({ ...state, paymentOptions: paymentOptions }, cart, environment, orderId);
      const evaluatePayload = state.evaluatePayload?.length > 0 ? JSON.parse(state.evaluatePayload) : {};
      (window as any).fc.setOrderId({ externalOrderId: evaluatePayload?.OrderId || orderId });

      if (state?.state) {
        // @ts-ignore
        body.billingInformation.state = state?.state;
      }

      if (state?.saveAddress) {
        // @ts-ignore
        body.billingInformation = { ...body.billingInformation };
      }

      localStorage.setItem('state', JSON.stringify(state));
      localStorage.setItem('cart', JSON.stringify(cart));
      // console.log('JSON.stringify(body)', JSON.stringify(body));

      // const transactionName = state.responseCode === 100 || state.responseCode === '100' ? 'eligibility' : 'evaluate';
      let transactionName = 'evaluate';

      if (state.useSale) {
        transactionName = 'sale';
      }

      if (state?.evaluatePayload?.length > 10) {
        body = JSON.parse(state.evaluatePayload);
      }
      if (paymentOptions === PaymentOptions.mit) {
        // {
        //   SubscriptionId = Guid.NewGuid().ToString(),
        //     Interval = "monthly",
        //     Price = evaluateRequest.Transaction.Amount, //.ToString(),
        //     Currency = evaluateRequest.Transaction.Currency
        // };

        // @ts-ignore
        body.Subscription = {
          PaymentNumber: state.paymentNumber?.length > 0 ? state.paymentNumber : null,
          SubscriptionId: state.subscriptionId?.length > 0 ? state.subscriptionId : uuidv4(),
          Interval: state.subscriptionInterval,
          Price: body.transaction.amount,
          Currency: body.transaction.currency,
        };
        await eligibility(body, environment, transactionName);
        // navigate('/mit');
        // eslint-disable-next-line no-restricted-globals
        parent.postMessage({ message: 'redirect', url: `/mit-message` }, '*');
        return;
      } else {
        eligibility(body, environment, transactionName);
      }

      // if (state.responseCode === 100 || state.responseCode === '100') {
      //   setTimeout(() => {
      //     setLoading(false);
      //   }, 2000);
      //   return;
      // }

      const urls: any = {};
      ['successUrl', 'rejectUrl', 'cancelUrl'].forEach(el => {
        if (state[el] && state[el]?.length > 10) {
          // @ts-ignore
          urls[el] = state[el];
        }
      });
      const flow: { ConsentFlowConfiguration?: number } = {};

      const initObject = {
        externalOrderId: body.OrderId,
        ...urls,
        ...flow,
        // @ts-ignore
        isCypress: !!window?.Cypress,
      };

      if (redirect !== 'modal') {
        initObject.container = 'iframe-container';
        initObject.size = iframeSize;
      }

      if (state.closeLoaderCallback) {
        initObject.closeLoader = () => setLoading(false);
      }

      if (state.openLoaderCallback) {
        initObject.openLoader = () => setLoading(true);
      }

      setTimeout(() => {
        if (
          location.pathname !== '/demo/iframe/challenge-frictionless/' &&
          location.pathname !== '/demo/iframe/frictionless/' &&
          (!state.closeLoaderCallback || state.openLoaderCallback)
        ) {
          setLoading(false);
        }
      }, 2000);
      setTimeout(() => {
        if (redirect === 'new_tab') {
          const href = `/iframe-desktop?orderId=${orderId}&iframeSize=${iframeSize}`;
          window?.open(href, '_blank');
        } else if (redirect === 'same_page') {
          navigate(`/iframe-desktop`, { ...initObject });
        } else if (state.isAsynchronous) {
          (window as any).UIWidget.InitUi(initObject);
        }
      }, 2200);
    }
  }

  async function handleCheckout(environment: Environments) {
    // (window as any)?.UIWidget?.InitUi({ orderSessionKey: '4CE65C9C-0099-40A1-8357-70CB5F4505B4' });
    // return;
    //
    // // FIXME
    // // eslint-disable-next-line no-unreachable
    const isValid = await validateSate();
    if (!isValid) {
      return;
    }

    setLoading(true);
    paymentHandler();
  }

  async function validateSate() {
    return await VALIDATION_SCHEMA.validate(state, { abortEarly: false })
      .then(() => {
        setErrors({});
        return true;
      })
      .catch(err => {
        const newErrors = {};
        err?.inner?.forEach((e: any) => {
          // @ts-ignore
          newErrors[e.path] = e.message;
        });
        setErrors(newErrors);
        return false;
      });
  }

  return (
    <div className="Checkout">
      <div className="checkout-grid">
        <div className="step-container">
          {step === 1 && <StepFirst state={state} setState={setState} />}
          {step === 2 && <StepSecond state={state} setState={setState} />}
          {step === 3 && <StepThird state={state} setState={setState} />}

          <div className="buttons">
            {step > 1 && (
              <Button variant="outlined" className="prev-step-btn" onClick={() => setStep(step - 1)} id="previous">
                Previous step
              </Button>
            )}
            {step < 3 && (
              <Button variant="outlined" onClick={() => setStep(step + 1)} id="next">
                Next step
              </Button>
            )}

            {step === 3 && (
              <Button variant="outlined" onClick={() => handleCheckout(environment)} id="submit" disabled={loading}>
                Checkout
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSteps;
